module.exports = __webpack_public_path__ + "img/finger.2f239d1d.png";